
export const inputClass = `w-full rounded-xl border-4 border-blue-dark bg-purple-light disabled:bg-white text-purple placeholder-jeans text-4xl p-4 mt-1`;
export const darkInputClass = `${inputClass} bg-violet`;
